<template>
  <v-app-bar color="primary" :clipped-left="$vuetify.breakpoint.lgAndUp" dark app>
    <v-app-bar-nav-icon v-show="auth" @click.stop="$emit('update:drawer', !drawer)"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ $t('查證系統') }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu
        left
        bottom
        v-if="auth"
      >
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          {{ user.vendor.no }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="identity in identities"
          :key="identity.id"
          @click="login(identity.api_token)"
        >
         {{ identity.vendor.no }} - {{ identity.vendor.name }}
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
        left
        bottom
      >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-avatar :size="32">
            <img :src="flags[$root.$i18n.locale]" :alt="$root.$i18n.locale">
          </v-avatar>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="locale in locales"
          :key="locale"
          @click="() => $root.$i18n.locale = locale"
        >
          <v-avatar :size="32">
            <img :src="flags[locale]" :alt="locale">
          </v-avatar>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

import en from '../../../img/flag-en.svg';
import id from '../../../img/flag-id.svg';
import th from '../../../img/flag-th.svg';
import vi from '../../../img/flag-vi.svg';
import zhTw from '../../../img/flag-zh-tw.svg';

export default {
  props: {
    drawer: Boolean,
  },

  computed: {
    ...mapState(['identities', 'user']),
    ...mapGetters(['auth'])
  },

  data() {
    return {
      locales: [
        'zh-tw',
        'en',
        'th',
        'id',
        'vi',
      ],
      flags: {
        'zh-tw': zhTw,
        'en': en,
        'th': th,
        'id': id,
        'vi': vi,
      }
    }
  },

  methods: {
    async login(token) {
      await this.loginByToken(token);
      window.location.reload();
    },

    ...mapActions(['loginByToken']),
  },
}
</script>
